export const GET_TAG = 'REQUIREMENT/get_tag';
export const REMOVE_TAG = 'REQUIREMENT/remove_tag';
export const GET_REQUIREMENT_ITEM = 'REQUIREMENT/GET_REQUIREMENT_ITEM';

export const GET_REQUIREMENT_LIST = 'REQUIREMENT/GET_REQUIREMENT_LIST';
export const GET_PERMIT_TYPE_LIST = 'REQUIREMENT/GET_PERMIT_TYPE_LIST';
export const UPDATE_APPLICATION_REQUIREMENT = 'REQUIREMENT/UPDATE_APPLICATION_REQUIREMENT';
